/* eslint-disable import/no-cycle */
import axios from 'axios';
import { getParams } from '../util';

const {
  REACT_APP_CARRIER_ID = 'nm',
  REACT_APP_NODE_ENV = 'dev',
  REACT_APP_LIFETIME_URL: LIFETIME_URL,
} = process.env;

const ARGUS_API = '/api/v1/argus/';
const SENSITIVE_KEYS = ['access_token', 'data'];
const BEARER_TOKEN = 'Bearer';

const ARGUS_BASE_URL =
  REACT_APP_NODE_ENV === 'local'
    ? 'http://localhost:5062/api/v1/argus'
    : `${LIFETIME_URL}${ARGUS_API}`;

const loggerInstance = axios.create({
  method: 'POST',
  baseURL: ARGUS_BASE_URL,
  timeout: 1000 * 15,
  headers: {
    'Content-Type': 'application/json',
    'x-service': `${REACT_APP_CARRIER_ID}${REACT_APP_NODE_ENV}`,
  },
});

/**
 * Build and return customized message with uid and other options
 *
 * eg: docusign:: Already signed - uid: abad6-fbbf... - {\"status\":false,\"error\":\"Already signed\"}
 */
const buildLogMessage = ({ module, message, data }) => {
  const uid = getParams('uid');
  let logMessage = `Logger-${REACT_APP_CARRIER_ID}-${REACT_APP_NODE_ENV}::`;

  if (uid) logMessage = ` uid: ${uid}`;
  if (module) logMessage += ` ${uid ? '- ' : ''}${module}`;

  logMessage += ` - ${message}`;

  if (data) logMessage += ` - ${JSON.stringify(data)}`;

  return logMessage;
};

const removeSensitiveInfo = (obj) => {
  if (Array.isArray(obj)) {
    obj.forEach((item) => removeSensitiveInfo(item));
  } else if (obj && typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      if (
        SENSITIVE_KEYS.includes(key.toLowerCase()) ||
        (typeof obj[key] === 'string' && obj[key].includes(BEARER_TOKEN))
      ) {
        delete obj[key];
      } else {
        removeSensitiveInfo(obj[key]);
      }
    });
  }
};

export { loggerInstance, buildLogMessage, removeSensitiveInfo };
